import { forwardRef, Ref } from 'react';
import { PopoverStateReturn, VisuallyHidden } from 'reakit';
import {
  OutlinedClose,
  OutlinedInformation,
  OutlinedQuestion,
} from '@mos-cat/ds-icons';
import { pxToRem } from '@mos-cat/ds-theme';
import { Box } from '../Box/Box';
import { PopoverDisclosure } from './Popover';
import { useRequiredPropWarning } from '../hooks/useRequiredPropWarning';
import { WHCM } from '../constants';
import { UtilityButton } from '../UtilityButton/UtilityButton';

/**
 * @public
 */
export type InfoPopoverDisclosureProps = {
  /**
   * Иконка в кнопке.
   */
  icon?: 'info' | 'question';
  /**
   * Подпись кнопки для скринридера
   */
  label: string;
  popoverState: PopoverStateReturn;
};

/**
 * @public
 */
export const InfoPopoverDisclosure = forwardRef(
  (
    { icon = 'info', popoverState, label }: InfoPopoverDisclosureProps,
    ref: Ref<HTMLButtonElement>
  ) => {
    useRequiredPropWarning(Boolean(label), 'InfoPopoverDisclosure', 'label');

    let Icon = {
      info: OutlinedInformation,
      question: OutlinedQuestion,
    };

    return (
      <PopoverDisclosure
        ref={ref}
        as={UtilityButton}
        {...popoverState}
        styles={{
          boxSizing: 'border-box',
          height: pxToRem(32),
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 'button',
          lineHeight: 'btn32LineHeight',
          border: 1,
          fontSize: 'btn32FontSize',
          borderColor: 'transparent',
          '.popoverIcon': {
            color: 'popoverInfoColor',
          },

          '&:hover .popoverIcon': {
            color: 'popoverInfoHoverColor',
          },

          '&:active .popoverIcon': {
            color: 'popoverInfoActiveColor',
          },
          [WHCM]: {
            '[class*="symbol"]': {
              fill: 'Highlight',
            },
          },
        }}
      >
        <VisuallyHidden>{label}</VisuallyHidden>
        <Box as="span" display="flex" alignItems="center">
          <Box as="span" className="popoverIcon" aria-hidden>
            {popoverState.visible ? (
              <Box as={OutlinedClose} />
            ) : (
              <Box as={Icon[icon]} />
            )}
          </Box>
        </Box>
      </PopoverDisclosure>
    );
  }
);
